/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';


export interface ResourcePoolUnassignSpec { 
    /**
     * Provider id
     */
    provider_id: string;
    provider_type: ResourcePoolProviderType;
    /**
     * Reconfigure IRR.
     */
    reconfigure_irr?: boolean;
}
export namespace ResourcePoolUnassignSpec {
}


